(function () {
  /**
   * @ngdoc module
   * @name binky.core.help-search
   * @description The module for HelpSearch service.
   */
  angular.module('binky.core.help-search', [
    'binky.core.common.list',
    'binky.core.lodash',
    'binky.core.url-utils',
  ]);
})();
